export default __webpack_public_path__ + "static/media/subject_icon.1d143a64.svg";